import React, { useState, useEffect, useMemo } from 'react'
import lodash from 'lodash'
import styled from 'styled-components'

import Field from '../../../../../../../1stlog-ui/src/components/Field'
import NumberInput from '../../../../../../../1stlog-ui/src/components/NumberInput'

const Wrapper = styled.div``

const Count = (props) => {
  const {} = props

  return (
    <Wrapper>
      <Field
        name="count"
        label={i18n.t('count', 'Anzahl')}
        tooltip={i18n.t(
          'tt_count_inner_packages',
          'Bitte tragen Sie hier die Anzahl der Innenverpackungen, welche mit den in diesem Eintrag aufgeführten Angaben übereinstimmen, ein.'
        )}
        required
      >
        <NumberInput mustBePositive min={1} max={100} noMargin block />
      </Field>
    </Wrapper>
  )
}

export default Count
